import { signInWithRedirect } from "aws-amplify/auth";

type PropsType = {
    federatedIdName: string;
    origin?: string;
}

function FederatedSignIn(props: Readonly<PropsType>) {
    return (
        <div className="flex flex-col items-center text-center">
            <p>
                In order to proceed please click to authenticate
            </p>
            <button
                className="bg-gray-200 border border-gray-400 rounded-lg py-2 px-4"
                onClick={async () => {
                    if (props.origin) {
                        sessionStorage.setItem('scomp.oktaRedirectUrl', props.origin);
                    }
                    await signInWithRedirect({
                        provider: {
                            custom: props.federatedIdName
                        }
                    });
                }
                }>
                Okta Sign In
            </button>
        </div>
    );
}

export default FederatedSignIn;